<template>
  <modal title="Forgotten Scan" @close="$emit('close')">
    <template #content>
      <Form
        method="dialog"
        v-slot="{ errors }"
        class="floating-labels p-1rem"
        ref="form"
      >
        <formGroup
          :title="'Start Date'"
          v-model="model.StartDate"
          type="date"
          :errors="errors"
          :rules="{ required: true }"
          @keydown.enter="save"
          :max="
            model.EndDate == null || model.EndDate == ''
              ? '9999-12-31'
              : model.EndDate
          "
          @blur="dateControl('start')"
        ></formGroup>
        <formGroup
          :title="'End Date'"
          v-model="model.EndDate"
          type="date"
          :errors="errors"
          :rules="{ required: true }"
          @keydown.enter="save"
          max="9999-12-31"
          :min="
            model.StartDate == null || model.StartDate == ''
              ? '0001-01-01'
              : model.StartDate
          "
          @blur="dateControl('end')"
        ></formGroup>
      </Form>
    </template>
    <template #foot>
      <Btn class="btn-success btn-md" @click="save" :process="process"
        >Forgotten Scan</Btn
      >
    </template>
  </modal>
</template>

<script>
import axios from "axios";
export default {
  name: "ForgottenScan",
  data() {
    return {
      model: {
        StartDate: "2024-08-15",
        EndDate: "2024-08-20",
      },
      errs: {},
      process: false,
    };
  },
  created() {
    this.model.StartDate = this.$moment(
      new Date().setDate(new Date().getDate() - 30)
    ).format("YYYY-MM-DD");
    this.model.EndDate = this.$moment(new Date()).format("YYYY-MM-DD");
  },
  methods: {
    dateControl(type) {
      if (type == "start") {
        if (new Date(this.model.EndDate) <= new Date(this.model.StartDate)) {
          this.model.EndDate = this.$moment(
            new Date(this.model.StartDate).setMonth(
              new Date(this.model.StartDate).getMonth() + 1
            )
          ).format("YYYY-MM-DD");
        }
        if (
          (new Date(this.model.EndDate).getTime() -
            new Date(this.model.StartDate).getTime()) /
            (24 * 60 * 60 * 1000) >
          31
        ) {
          this.model.EndDate = this.$moment(
            new Date(this.model.StartDate).setMonth(
              new Date(this.model.StartDate).getMonth() + 1
            )
          ).format("YYYY-MM-DD");
        }
      } else {
        if (new Date(this.model.EndDate) <= new Date(this.model.StartDate)) {
          this.model.StartDate = this.$moment(
            new Date(this.model.EndDate).setMonth(
              new Date(this.model.EndDate).getMonth() - 1
            )
          ).format("YYYY-MM-DD");
        }
        if (
          (new Date(this.model.EndDate).getTime() -
            new Date(this.model.StartDate).getTime()) /
            (24 * 60 * 60 * 1000) >
          31
        ) {
          this.model.StartDate = this.$moment(
            new Date(this.model.EndDate).setMonth(
              new Date(this.model.EndDate).getMonth() - 1
            )
          ).format("YYYY-MM-DD");
        }
      }
    },
    save() {
      this.$refs.form.validate().then((valid) => {
        if (valid.valid) {
          this.process = true;
          axios
            .post(
              `https://api.kolayrez.com/mailworker/ForgottenScan`,
              this.model
            )
            .then((response) => {
              this.process = false;
              this.$swal({
                icon: "success",
                title: "Success",
                timer: 2000,
                text: response.data,
                confirmButtonText: "Okey",
              });
              this.$emit("close");
            })
            .catch((err) => {
              this.process = false;
              this.$isError(err);
            });
        }
      });
    },
  },
};
</script>

<style></style>
